/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiTheme from '@here/lui-base/lui-theme'

export default class LuiBrandmembranelayerTheme extends LuiTheme {
  constructor() {
    super()
    console.warn(`[LUI] <${this.constructor.is}> component is deprecated and will be removed in future versions.
➜ HINT: Remove this element from your markup as it plays no role in current and future versions.`)
  }

  static get is() {
    return 'lui-brandmembranelayer-theme'
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-layer-theme/lui-brandmembranelayer-theme.js
// module id = 161
// module chunks = 0 1 19